/* ============================================================
   gift-timer.js — Hediye sayaçları (Dalga 2'de gece-yarısı moduna uyarlandı)
   ------------------------------------------------------------
   İKİ mod:
   A) PDP gece-yarısı countdown (HH:MM:SS) — swiss "Bugüne özel" aciliyet.
      Hedef: [data-gift-timer] (eski #sg-gift-timer).
      setHours(24,0,0,0) → bu gecenin yarısına kalan süre.
   B) Sepet hediye timer (10dk, Bonheur) — KORUNDU. [data-cart-gift-timer]
      veya #cart-timer-text + .gift-timer-header mevcutsa çalışır.
   ============================================================ */
(function () {
  'use strict';

  /* ───────── A) PDP gece-yarısı countdown ───────── */
  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function msToMidnight() {
    var now = new Date();
    var midnight = new Date(now);
    midnight.setHours(24, 0, 0, 0);
    return midnight - now;
  }

  function fmtMidnight(ms) {
    if (ms < 0) ms = 0;
    var h = Math.floor(ms / 3600000);
    var m = Math.floor((ms % 3600000) / 60000);
    var s = Math.floor((ms % 60000) / 1000);
    return pad(h) + ':' + pad(m) + ':' + pad(s);
  }

  var midnightEls = document.querySelectorAll('[data-gift-timer]');
  if (midnightEls.length) {
    var midnightInterval = null;
    var tick = function () {
      var txt = fmtMidnight(msToMidnight());
      midnightEls.forEach(function (el) { el.textContent = txt; });
    };
    var startMidnight = function () {
      if (midnightInterval) return;
      tick();
      midnightInterval = setInterval(tick, 1000);
    };
    var stopMidnight = function () {
      if (!midnightInterval) return;
      clearInterval(midnightInterval);
      midnightInterval = null;
    };
    /* Sekme gizliyken saniye tick'i pil/CPU harcamasın; geri dönünce
       anında re-sync (tick()) ile doğru değer gösterilir. */
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stopMidnight();
      else startMidnight();
    });
    startMidnight();
  }

  /* ───────── B) Sepet hediye timer (Bonheur, korundu) ───────── */
  var cartTextEl = document.getElementById('cart-timer-text') ||
                   document.querySelector('[data-cart-gift-timer]');
  if (cartTextEl && typeof window.__getCart === 'function') {
    var KEY = 'bonheur_gift_timer';
    var DURATION = 10 * 60 * 1000;
    var header = function () { return document.querySelector('.gift-timer-header'); };

    var hide = function () { var el = header(); if (el) el.style.display = 'none'; };
    var fmt = function (ms) {
      var m = Math.floor(ms / 60000), s = Math.floor((ms % 60000) / 1000);
      return pad(m) + ':' + pad(s);
    };
    var hasGift = function (cart) {
      return cart.items.some(function (i) {
        return i.properties && i.properties._gift === 'true';
      });
    };

    var startTimer = function () {
      var end = Date.now() + DURATION;
      localStorage.setItem(KEY, JSON.stringify({ endTime: end }));
      countdown(end);
    };

    var cartInterval = null;
    function countdown(end) {
      /* Önceki interval'i temizle: gift:added tekrar tetiklenirse
         setInterval'ler üst üste binmesin (perf sızıntısı guard'ı). */
      if (cartInterval) { clearInterval(cartInterval); cartInterval = null; }
      cartTextEl.textContent = fmt(end - Date.now());
      cartInterval = setInterval(function () {
        var r = end - Date.now();
        if (r <= 0) { clearInterval(cartInterval); cartInterval = null; startTimer(); return; }
        cartTextEl.textContent = fmt(r);
      }, 1000);
    }

    window.__getCart().then(function (cart) {
      if (!hasGift(cart)) { hide(); localStorage.removeItem(KEY); return; }
      var s = localStorage.getItem(KEY);
      if (s) {
        var d = JSON.parse(s);
        if (Date.now() < d.endTime) countdown(d.endTime);
        else startTimer();
      } else {
        startTimer();
      }
    }).catch(function (err) {
      /* fire-and-forget: sessiz yutma yok */
      console.error('[gift-timer] cart fetch failed', err);
    });

    document.documentElement.addEventListener('gift:added', function () { startTimer(); });
  }
})();
